export const ADD_STATE_INIT_ACTION = "ADD_STATE_INIT_ACTION";
export const ADD_STATE_SUCCESS_ACTION = ADD_STATE_INIT_ACTION + "_SUCCESS";
export const ADD_STATE_FAIL_ACTION = ADD_STATE_INIT_ACTION + "_ERROR";

export const FETCH_STATELIST_INIT_ACTION = "FETCH_STATELIST_INIT_ACTION";
export const FETCH_STATELIST_SUCCESS_ACTION =
  FETCH_STATELIST_INIT_ACTION + "_SUCCESS";
export const FETCH_STATELIST_FAIL_ACTION =
  FETCH_STATELIST_INIT_ACTION + "_ERROR";

export const DELETE_STATE_INIT_ACTION = "DELETE_STATE_INIT_ACTION";
export const DELETE_STATE_SUCCESS_ACTION =
  DELETE_STATE_INIT_ACTION + "_SUCCESS";
export const DELETE_STATE_FAIL_ACTION = DELETE_STATE_INIT_ACTION + "_ERROR";

export const UPDATE_STATE_INIT_ACTION = "UPDATE_STATE_INI_ACTION";
export const UPDATE_STATE_SUCCESS_ACTION =
  UPDATE_STATE_INIT_ACTION + "_SUCCESS";
export const UPDATE_STATE_FAIL_ACTION = UPDATE_STATE_INIT_ACTION + "_ERROR";

export const FETCH_STATE_SEARCH_INIT_ACTION = "FETCH_STATE_SEARCH_INIT_ACTION";
export const FETCH_STATE_SEARCH_SUCCESS_ACTION =
  FETCH_STATE_SEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_STATE_SEARCH_FAIL_ACTION =
  FETCH_STATE_SEARCH_INIT_ACTION + "_ERROR";

export function addState(value) {
  // console.log("ADD romy");
  return {
    type: ADD_STATE_INIT_ACTION,
    value: value
  };
}

export function stateViewList() {
  // console.log("romy");
  return {
    type: FETCH_STATELIST_INIT_ACTION
  };
}

export function deleteState(items) {
  return {
    type: DELETE_STATE_INIT_ACTION,
    items: items
  };
}
export function editState(value) {
  return {
    type: UPDATE_STATE_INIT_ACTION,
    value: value
  };
}
export function stateSearch(value) {
  return {
    type: FETCH_STATE_SEARCH_INIT_ACTION,
    value: value
  };
}
export function stateSlectedPage(value) {
  return {
    type: FETCH_STATELIST_INIT_ACTION,
    value: value
  };
}
